<template>
  <div>您访问的页面暂不可用</div>
</template>

<script>
export default {
  name: "null",
};
</script>
